<script lang="ts">
	import { setHugeHeadingParallax } from "@utils/setHugeHeadingParallax.js";
	import Heading, { type HeadingProps } from "./common/Heading.svelte";

	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	const { class: customClass, ...props }: HeadingProps = $props();
	let element = $state<HTMLHeadingElement>();

	function setScrollPercentage(): void {
		if (element) {
			setHugeHeadingParallax(element);
		}
	}

	$effect(() => {
		if (element) {
			setHugeHeadingParallax(element);
		}
	});
</script>

<svelte:window onscroll={setScrollPercentage} />

<!-- size classes defined in general.css -->
<Heading bind:element {...props} class={[customClass, "huge-heading text-cmcsecondary"]} />
